import { Route, Routes } from 'react-router-dom';
import {
  BUSSHELTER_SINGLE,
  BUS_SINGLE,
  COMMON_HOME,
  COMMON_HOME_SEARCH,
  CORPORATES_SINGLE,
  CORPORATE_SINGLE,
  CREATE_SUPPLIER,
  DASHBOARD_SUPPLIER,
  EDUCATION_INSTITUTE_SINGLE,
  GANTRY_SINGLE,
  GYM_SINGLE,
  HORDING_SINGLE,
  HOSPITAL_SINGLE,
  RADIO_CHANNEL_SINGLE,
  RETAILSHOP_SINGLE,
  SALON_SINGLE,
  SOCIETY_HOME,
  SOCIETY_HOME_SEARCH,
  SOCIETY_SINGLE,
  TV_CHANNEL_SINGLE,
} from '../constants/routes.constants';
import SupplierDashboard from './SupplierDashboard';
import CreateSupplier from './CreateSupplier';
import './styles/main.css';
import './styles/login.css';
import './styles/style.css';
import './styles/machadalo.css';
// import './bootstrap/css/bootstrap.min.css';
import Society from './components/society/Society';
import SocietyHome from './components/society/SocietyHome';
import Corporate from './components/corporate/Corporate';
import Gym from './components/gym/Gym';
import Salon from './components/salon/Salon';
import BusShelter from './components/busshelter/BusShelter';
import RetailShop from './components/retailshop/RetailShop';
import EducationInstitute from './components/educationInstitute/EducationInstitute';
import Hording from './components/hording/Hording';
import Bus from './components/bus/Bus';
import Gantry from './components/gantry/Gantry';
import RadioChannel from './components/radio_channel/RadioChannel';
import TvChannel from './components/tv_channel/TvChannel';
import Corporates from './components/corporates/Corporates';
import Hospital from './components/hospital/Hospital';
import CommonHome from './components/common/CommonHome';

export default function ManageSupplier(props) {

  return (
    <>
      <Routes>
        <Route exact path={DASHBOARD_SUPPLIER} element={<SupplierDashboard />} />
        <Route exact path={CREATE_SUPPLIER} element={<CreateSupplier />} />
        <Route exact path={SOCIETY_HOME} element={<SocietyHome />} />
        <Route exact path={SOCIETY_HOME_SEARCH} element={<SocietyHome />} />
        <Route exact path={SOCIETY_SINGLE} element={<Society />} />
        <Route exact path={COMMON_HOME} element={<CommonHome />} />
        <Route exact path={CORPORATE_SINGLE} element={<Corporate />} />
        <Route exact path={GYM_SINGLE} element={<Gym />} />
        <Route exact path={SALON_SINGLE} element={<Salon />} />
        <Route exact path={BUSSHELTER_SINGLE} element={<BusShelter />} />
        <Route exact path={RETAILSHOP_SINGLE} element={<RetailShop />} />
        <Route exact path={EDUCATION_INSTITUTE_SINGLE} element={<EducationInstitute />} />
        <Route exact path={HORDING_SINGLE} element={<Hording />} />
        <Route exact path={BUS_SINGLE} element={<Bus />} />
        <Route exact path={GANTRY_SINGLE} element={<Gantry />} />
        <Route exact path={RADIO_CHANNEL_SINGLE} element={<RadioChannel />} />
        <Route exact path={TV_CHANNEL_SINGLE} element={<TvChannel />} />
        <Route exact path={CORPORATES_SINGLE} element={<Corporates />} />
        <Route exact path={HOSPITAL_SINGLE} element={<Hospital />} />
        <Route exact path={COMMON_HOME_SEARCH} element={<CommonHome />} />
      </Routes>
    </>
  );
}
